import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { adminLogin, setToken } from "../lib/api";
import { BrandMark } from "../lib/icons";
import { useSettings } from "../context/SettingsContext";

export default function LoginPage() {
  const nav = useNavigate();
  const s = useSettings();
  const [u, setU] = useState("");
  const [p, setP] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      const res = await adminLogin(u.trim(), p);
      setToken(res.token);
      nav("/admin", { replace: true });
    } catch (e) {
      setErr(e?.response?.status === 401 ? "Incorrect username or password." : "Could not sign in. Please try again.");
    } finally { setBusy(false); }
  };

  return (
    <div className="login-wrap">
      <form className="login-card" onSubmit={submit}>
        <div className="login-brand"><BrandMark /><span>{s.brand}</span></div>
        <h1>Admin sign in</h1>
        <p className="login-sub">Sign in to manage leads, operators and settings.</p>
        <div className="login-field">
          <label>Username</label>
          <input autoFocus autoComplete="username" value={u} onChange={(e) => setU(e.target.value)} placeholder="Enter username" />
        </div>
        <div className="login-field">
          <label>Password</label>
          <input type="password" autoComplete="current-password" value={p} onChange={(e) => setP(e.target.value)} placeholder="Enter password" />
        </div>
        {err ? <div className="login-err" role="alert">{err}</div> : null}
        <button className="login-btn" type="submit" disabled={busy}>{busy ? "Signing in…" : "Sign in"}</button>
        <a className="login-back" href="/">← Back to website</a>
      </form>
    </div>
  );
}
